import { useState, useEffect, MouseEvent } from 'react';
import { deleteStore, getStores, postStore, putStore } from './Store.service';
import Form from './form/Form.component';
import FormStore from './form/FormStore.component';
import Table from '../../component/table/Table.component';
import {
  Action,
  ACTION_VIEW,
  ACTION_SELECTED,
  ACTION_SWITCH,
  ACTION_DELETE,
  ACTION_EDIT_SUBMIT,
  ACTION_EDIT,
} from '../../component/table/interfaces/TableInterface';
import { useSnackbar } from '../../context/Snackbar';
import StoreList, { Store } from './interfaces/Store';
import { INITIAL_PAGINATION } from '../../component/table/component/pagination/utils/Pagination';
import { INITIAL_VALUES } from './utils/INITIAL_VALUES';
import { HEAD_CELL } from './utils/HEAD_CELL';
import { useHistory } from 'react-router-dom';
import { AxiosError } from 'axios';
import GridComponent from '../../component/grid/GridComponent.component';
import { compare } from '../../utils/order/compare';
import ButtonComponent from '../../component/buttton/Button.component';
import { useStore } from '../../context/Store';
import { Pagination } from '../../component/table/interfaces/Pagination';
import useModal from '../../hooks/useModal';
import ModalDelete from '../../component/modal/ModalDelete.component';
import { AuthorizationOption } from '../../authorization/Authorization';
import Modal from '../../component/modal/Modal.component';
import FormStoreCrud from './form/FormStoreCrud.component';
import ButtonFormFullWithLoading from '../../component/buttton/ButtonFormFullWithLoading.component';
import { formatCepString } from '../../utils/format/FormatCep';
import { formatTelephone } from '../../utils/format/FormatTelefone';
import { formatHourString } from '../../utils/format/FormatHour';
import SelectSearch, { IOption } from '../../component/select/SelectSearch';
import { IFlag } from './utils/Flags';
import { AUTORIZATION } from '../../enum/authorization/Authorization';
import { getSelectFlagStorage, setSelectFlagStorage } from './utils/StoreStorage';

export default function StoreComponent() {
  let history = useHistory();
  const { setSnackbar } = useSnackbar();
  const { setFlag, setStore, flag, store, setSelectedStore, arrayFlags } = useStore();

  const [open, addModal] = useModal();
  const [saving, setSaving] = useState<boolean>(false);

  const [openDelete, addModalDelete] = useModal();
  const [openEdit, addModalEdit] = useModal();
  const [openRemoveSelect, addModalRemoveSelect] = useModal();

  const [selectFlag, setSelectFlag] = useState<IOption>(getSelectFlagStorage());
  const [stores, setStores] = useState<Store[]>([]);
  const [storeAux, setStoreAux] = useState<Store[]>([]);
  const [request, setRequest] = useState<boolean>(true);
  const [buttonFilter, setButtonFilter] = useState<boolean>(false);
  const [pagination, setPagination] = useState<Pagination>(INITIAL_PAGINATION);
  const [authorization, setAuthorization] = useState(false);

  const [storeEdit, setStoreEdit] = useState<Store>();

  useEffect(() => {
    setSelectFlagStorage(selectFlag);
    selectFlag.value ? response(selectFlag.value) : setRequest(false);

    const permission = AuthorizationOption('Manutenção Horário de Lojas');

    setAuthorization(permission);

    return () => {
      setRequest(true);
    };
  }, [selectFlag.value]);

  const response = async (flag: String) => {
    await getStores(flag)
      .then((res) => {
        if (res.data) {
          const response: Store[] = filter(res.data);
          setStores([...response]);
          setStoreAux([...response]);
        }
      })
      .catch((error: AxiosError) => {
        console.log(error.response?.data);
        console.log(error);
        setSnackbar({ msg: 'Erro ao consultar loja!', type: 'error' });
      })
      .finally(() => {
        setRequest(false);
      });
  };

  const handleClickAction = (action: Action, storeObj: Store, index: number) => {
    if (action === ACTION_VIEW) {
      setSelectedStore(storeObj);
      return history.push(`/loja/${storeObj.id}`, { store });
    }
    if (action === ACTION_SELECTED) {
      if (store !== String(storeObj.id)) {
        return addModal(`${String(storeObj.id)}-${index}`);
      } else {
        addModalRemoveSelect(String(storeObj.id));
      }
    }

    if (action === ACTION_DELETE) {
      if (store === storeObj.id) {
        setSnackbar({ msg: 'Não é possível excluir a loja que está selecionada!', type: 'error' });
      } else {
        return addModalDelete(storeObj.id);
      }
    }

    if (action === ACTION_EDIT) {
      if (store === storeObj.id) {
        setSnackbar({ msg: 'Não é possível editar a loja que está selecionada!', type: 'error' });
      } else {
        let editStore = { ...storeObj };
        editStore.Cep = formatCepString(editStore.Cep || '');
        editStore.managerPhone = formatTelephone(editStore.managerPhone || '');
        editStore.Telefone = formatTelephone(editStore.Telefone || '');
        editStore.semanaInicio = formatHourString(editStore.semanaInicio || '');
        editStore.semanaFim = formatHourString(editStore.semanaFim || '');
        editStore.sabadoInicio = formatHourString(editStore.sabadoInicio || '');
        editStore.sabadoFim = formatHourString(editStore.sabadoFim || '');
        editStore.domingoInicio = formatHourString(editStore.domingoInicio || '');
        editStore.domingoFim = formatHourString(editStore.domingoFim || '');

        if (editStore.Bairro) {
          if (editStore.Bairro.split(', ').length === 3) {
            editStore.Bairro = editStore.Bairro.split(', ')[1];
          } else {
            editStore.Bairro = editStore.Bairro.split(', ')[0];
          }
        }

        setStoreEdit(editStore);
        return addModalEdit(storeObj.id);
      }
    }
  };

  const filter = (store: StoreList[]) => {
    let storeAux: any[] = [];
    store.map((el: StoreList) => {
      el.Loja.Bairro = `${el.Loja.Logradouro}, ${el.Loja.Bairro}, ${el.Loja.NumeroEstabelecimento}`;
      storeAux.push(el.Loja);
      return el;
    });
    return storeAux;
  };

  const handleRequestSort = (_event: MouseEvent<unknown>, property: string) => {
    const isAsc = pagination.sort === property && pagination.order === 1;
    setStoreAux(storeAux.sort((a: any, b: any) => compare(a, b, property, isAsc ? -1 : 1)));
    setPagination({ ...pagination, sort: property, order: isAsc ? -1 : 1 });
  };

  const handleChangePage = (_event: unknown, newPage: number) => {
    setPagination({ ...pagination, page: newPage + 1 });
  };

  const handleSubmitSearch = (store: Store) => {
    let storeAux: Store[] = [...stores].filter((el: Store) => {
      let includesName: boolean =
        !store.Nome || el.Nome.toLocaleLowerCase().includes(store.Nome.toLocaleLowerCase());
      let includesNumber: boolean =
        !store.id ||
        String(el.id).toLocaleLowerCase().includes(String(store.id).toLocaleLowerCase());
      let includesCity: boolean =
        !store.Cidade ||
        (el.Cidade !== undefined &&
          el.Cidade.toLocaleLowerCase().includes(store.Cidade.toLocaleLowerCase()));
      let includesDistrict: boolean =
        !store.Bairro ||
        (el.Bairro !== undefined &&
          el.Bairro.toLocaleLowerCase().includes(store.Bairro.toLocaleLowerCase()));
      let includesUf: boolean =
        !store.UF ||
        (el.UF !== undefined && el.UF.toLocaleLowerCase().includes(store.UF.toLocaleLowerCase()));
      return includesName && includesNumber && includesCity && includesDistrict && includesUf;
    });
    const empty: boolean = !store.Nome && !store.id && !store.Cidade && !store.Bairro && !store.UF;
    setStoreAux(empty ? [...stores] : storeAux);
  };

  const pageSelect = (storeAux: Store[]) => {
    if (pagination.page) {
      return storeAux.slice((pagination.page - 1) * 30, pagination.page * 30);
    }
    return storeAux;
  };

  const registerStore = async (storeObj: Store) => {
    let goUpdate = false;

    if (storeObj.NumeroLoja) {
      goUpdate = true;
    }
    setSaving(true);

    try {
      if (!storeObj.flag_id) {
        storeObj.flag_id = flag;
      }
      storeObj.flag_id = selectFlag.value;
      storeObj.NumeroLoja = storeObj.id.replace(/\D/g, '');

      await (goUpdate ? putStore(storeObj) : postStore(storeObj));
      await response(storeObj.flag_id);
      setSnackbar({
        msg: `Loja foi ${goUpdate ? 'atualizada' : 'cadastrada'} com sucesso!`,
        type: 'success',
      });
    } catch (error) {
      console.log('Erro ao submeter loja!', error);
      setSnackbar({ msg: `Erro ao ${goUpdate ? 'atualizar' : 'cadastrar'} loja!`, type: 'error' });
    }

    setSaving(false);
    addModal(false);
    addModalEdit(false);
  };

  const handleClickDelete = async () => {
    if (store === String(openDelete)) {
      setSnackbar({ msg: 'Não é possível excluir a loja que está selecionada!', type: 'error' });
    } else {
      setRequest(true);
      await deleteStore(String(openDelete))
        .then((res) => {
          response(selectFlag.value);
          setSnackbar({ msg: 'Loja excluída com sucesso!', type: 'success' });
        })
        .catch((error) => {
          console.log('Erro ao excluir loja!', error);
          setSnackbar({ msg: 'Erro ao excluir loja!', type: 'error' });
        })
        .finally(function () {
          setRequest(false);
          addModalDelete(undefined);
        });
    }
  };

  const selectedStore = () => {
    let values: String[] = String(open).split('-');
    setStore(
      String(values[0]),
      storeAux[Number(values[1])].Nome,
      Number(values[1]),
      selectFlag.value
    );
    setFlag(selectFlag.value);
    return addModal('');
  };

  useEffect(() => {
    setSaving(false);
  }, [openEdit]);

  const formatArrayFlags = (): IOption[] => {
    const flagsOptions: IOption[] = [];

    arrayFlags.forEach((a: IFlag) => {
      flagsOptions.push({ label: String(a.flag), value: a.id });
    });

    return flagsOptions;
  };

  const handleChangeFlag = (selectOption: IOption) => {
    setStores([]);

    if (selectOption) {
      setSelectFlag(selectOption);
    } else {
      setSelectFlag({ label: '', value: '' });
    }
  };

  return (
    <>
      <ModalDelete
        open={!!open}
        handleClick={() => addModal('')}
        onClickSubmit={selectedStore}
        title='Deseja selecionar esta loja?'
      />

      <ModalDelete
        open={!!openRemoveSelect}
        handleClick={() => addModalRemoveSelect('')}
        onClickSubmit={() => {
          setStore('', '', 0, '');
          addModalRemoveSelect('');
          setFlag('');
        }}
        title='Deseja desselecionar esta loja?'
      />

      <GridComponent justify='space-between' alignItems='center'>
        <SelectSearch
          title='Bandeira'
          data={formatArrayFlags()}
          onChange={(event: any, selectOption: any) => handleChangeFlag(selectOption)}
          placeholder='Selecione...'
          value={selectFlag}
          request={request}
          sm={12}
          md={6}
          lg={3}
        />

        <GridComponent alignItems='flex-end'>
          {AuthorizationOption(AUTORIZATION.STORE_MANAGER) && (
            <Modal
              title='Criar loja'
              open={open === true}
              NoReload={true}
              disabled={!selectFlag.value || !AuthorizationOption(AUTORIZATION.STORE_MANAGER)}
              handleClick={() => addModal(!open)}
              marginButton='16px 16px 0px 0px'
              size='lg'
            >
              <FormStoreCrud
                initialValues={{ ...INITIAL_VALUES.Loja, flag_id: selectFlag.value }}
                handleSubmitForm={registerStore}
              >
                <ButtonFormFullWithLoading
                  disabled={saving || !selectFlag.value ? true : false}
                  saving={saving}
                  onClick={() => addModal(false)}
                />
              </FormStoreCrud>
            </Modal>
          )}

          {stores.length !== 0 && !request && authorization === true && (
            <ButtonComponent
              onClick={() => history.push('/manutencao-horarios')}
              title='Dados Complementares'
              size='medium'
              margin='16px 16px 0px 0px'
            />
          )}

          {stores.length !== 0 && !request && (
            <ButtonComponent
              onClick={() => setButtonFilter(!buttonFilter)}
              title='filtro'
              size='medium'
              margin='16px 0px 0px 0px'
            />
          )}
        </GridComponent>
      </GridComponent>

      <ModalDelete
        open={!!openDelete && openDelete !== true}
        handleClick={() => addModalDelete(undefined)}
        onClickSubmit={handleClickDelete}
        title='Confirma a exclusão dessa loja?'
      />

      <Modal open={!!openEdit} handleClick={() => addModalEdit(!openEdit)} size='lg'>
        <FormStoreCrud
          initialValues={storeEdit || { ...INITIAL_VALUES.Loja, flag_id: selectFlag.value }}
          handleSubmitForm={registerStore}
        >
          <ButtonFormFullWithLoading
            disabled={saving ? true : false}
            saving={saving}
            onClick={() => addModalEdit(false)}
          />
        </FormStoreCrud>
      </Modal>

      <br />
      <GridComponent justify='flex-start' alignItems='center' spacing={2}>
        {buttonFilter && (
          <FormStore initialValues={INITIAL_VALUES.Loja} handleSubmitForm={handleSubmitSearch} />
        )}
      </GridComponent>
      <br />
      <Table
        request={request}
        data={pageSelect(storeAux)}
        size={storeAux.length}
        headCells={HEAD_CELL}
        page={pagination.page}
        onChangePage={handleChangePage}
        actionSelected={store}
        handleClickAction={handleClickAction}
        order={pagination.order === 1 ? 'asc' : 'desc'}
        orderBy={pagination.sort}
        noActionEdit={!AuthorizationOption(AUTORIZATION.STORE_MANAGER)}
        noActionDelete={!AuthorizationOption(AUTORIZATION.STORE_MANAGER)}
        onRequestSort={handleRequestSort}
      />
    </>
  );
}
